{
    "WHATSAPP_TEMPLATES": {
        "MODAL": {
            "TITLE": "Whatsapp Templates",
            "SUBTITLE": "Veldu WhatsApp sniðmátið sem þú vilt senda",
            "TEMPLATE_SELECTED_SUBTITLE": "Process {templateName}"
        },
        "PICKER": {
            "SEARCH_PLACEHOLDER": "Search Templates",
            "NO_TEMPLATES_FOUND": "No templates found for",
            "LABELS": {
                "LANGUAGE": "Language",
                "TEMPLATE_BODY": "Template Body",
                "CATEGORY": "Category"
            }
        },
        "PARSER": {
            "VARIABLES_LABEL": "Variables",
            "VARIABLE_PLACEHOLDER": "Enter {variable} value",
            "GO_BACK_LABEL": "Go Back",
            "SEND_MESSAGE_LABEL": "Send Message",
            "FORM_ERROR_MESSAGE": "Please fill all variables before sending"
        }
    }
}
